/* * @Author: 孙福聪 * @Date: 2019-01-16 16:02:43 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-03-25 17:15:26 */
<template lang="pug">
  .teacher-home
    topNav(ref='topNav')
    .content
      .box
        router-view
</template>
<script>
import topNav from "@/components/Teacher/common/topNav.vue";
export default {
  components: {
    topNav
  },
  data() {
    return {
      userInfo: {
        src: "",
        name: ""
      }
    };
  },
  methods: {
    getByCode() {
      this.$http
        .userInfo({ code: this.$role.code })
        .then(res => {
          if (res.data.success) {
            // console.log(res);
            this.userInfo.name = res.data.data.name;
            this.userInfo.src = res.data.data.headImagePath;
          }
        })
        .catch(() => {
          this.$Message.error("服务器异常");
        });
    }
  },
  mounted() {
    this.getByCode();
  }
};
</script>

<style lang="stylus" scope>
@keyframes fade-in
  from
    height 0
  to
    height 128px
@keyframes fade-out
  from
    height 128px
  to
    height 0
.teacher-home
  .content
    margin 0 auto
    padding-top 108px
    width 100%
    min-height calc(100vh)
    min-width 1349px
    // width 1349px
    background #EEF2F5
    box-sizing border-box
    padding-bottom 120px
    .box
      width 1180px
      margin 0 auto
</style>
